<ion-header>
  <ion-toolbar>
      <ion-buttons slot="start">
        <ion-button (click)="cancel()"><ion-icon slot="start" name="close"></ion-icon></ion-button>
      </ion-buttons>
      <ion-title clas="ion-text-center">Email Ändern</ion-title>
  </ion-toolbar>
</ion-header>
<ion-content class="ion-padding">
<div class="ion-padding">
  <form id="accountForm" [formGroup]="emailChangeForm" (ngSubmit)="onChangeEmail()" novalidate>
    <ion-list>
      <ion-item>
        <ion-label position="stacked">
          Aktuelles Passwort
        </ion-label>
        <ion-input type="password" autofocus="true" autcomplete="password" inputmode="password" name="current_password" formControlName="current_password"></ion-input>
      </ion-item>
      <ion-item>
        <ion-label position="stacked">
          Neue Email Addresse
        </ion-label>
        <ion-input type="email" autcomplete="email" name="new_email" formControlName="new_email"></ion-input>
      </ion-item>
    </ion-list>
    <ion-button type="submit" size="block" [disabled]="!emailChangeForm.dirty || emailChangeForm.invalid">Email ändern</ion-button>
  </form>
</div>
</ion-content>
